import React from 'react'
import RouteApp from './routes/RouteApp';
import { AuthProvider } from './components/AuthContext/AuthContext';

const App = () => {
  return (
    <>
    <AuthProvider>
         <RouteApp />
    </AuthProvider>
 
    </>
  )
}

export default App